import { Injectable } from '@angular/core';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { filter, map, mergeMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { actualUserLoaded, initializeModule, loadActualUser, loadUserDetails, userLoaded } from '../actions/user.actions';
import { UserApiService } from '../services/user-api.service';
import { selectUserById } from 'common/store/genesys-cloud/users/selectors/user.selectors';

@Injectable()
export class GenesysCloudUserEffects {
  readonly init$ = createEffect(() => this.actions$.pipe(
    ofType(initializeModule),
    map(() => loadActualUser())
  ));

  readonly loadUser$ = createEffect(() => this.actions$.pipe(
    ofType(loadActualUser),
    mergeMap(() => this.userApi.getCurrentUser$()),
    map(user => actualUserLoaded({ user }))
  ));

  readonly loadUserDetails$ = createEffect(() => this.actions$.pipe(
      ofType(loadUserDetails),
      concatLatestFrom(({ userId }) => this.store.select(selectUserById(userId))),
      filter(([_, alreadyFetchedUser]) => !alreadyFetchedUser),
      mergeMap(([{ userId }]) => this.userApi.getUserById$(userId)),
      map(user => userLoaded({ user }))
    )
  );

  constructor(private readonly actions$: Actions,
              private readonly userApi: UserApiService,
              private readonly store: Store
  ) {
  }
}
